import { HStack, VStack, XButton, XIconButton, XImage, XText } from "IZOX/_X";
import { ColorX, GState, LocaleX } from "IZOX/STATIC";
import { observer } from "mobx-react";

function RegisterM({
  _closeReg,
  _toPage
}){
  if(!GState.showCreateAccount || GState.loggedIn) return null;
  return (
    <VStack bgColor={ColorX.CSS("Grass")} fullWidth height={118} flexShrink={0}>
      <HStack height={60} pH={10} spacing={20}>
        <XText bold color={ColorX.CSS("pureWhite")} fontSize={20} textAlign="|">
          {LocaleX.Parse({
            EN: "New user ? Create Account Now",
            TC: "新用戶？ 立即登記用戶"
          })}
        </XText>
        <XIconButton onPress={_closeReg} size={24}>
          <XImage source="/Images/Icons/close.png" noResize width={24} height={24}/>
        </XIconButton>
      </HStack>
      <HStack>
        <XButton onPress={() => {
          _closeReg();
          GState.UPDATE("registerStep", "userType");
          GState.UPDATE("registerFormData", {
            userType: "Agent"
          });
          _toPage("/Register");
        }} width={218} p={0}
          round={30} bW={2} pV={6} pH={24}
          bColor={ColorX.CSS("pureWhite")}
          color={ColorX.CSS("pureWhite")}>
          <HStack>
            <XText bold fontSize={16}>
              {LocaleX.Parse({
                EN: "Create account",
                TC: "登記用戶"
              })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    </VStack>
  );
}

export default observer(RegisterM);